import pageMain from '@/components/pages/dashboard/page-main/page-main.vue';
import pagePortfolio from '@/components/pages//dashboard/page-portfolio/page-portfolio.vue';
import pageInfo from '@/components/pages/dashboard/page-info/page-info.vue';
import pageNotifications from '@/components/pages/dashboard/page-notifications/page-notifications.vue';

export default [
  {
    path: '/dashboard',
    component: pageMain,
    props: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'portfolio',
        component: pagePortfolio,
      },
      {
        path: 'info',
        name: 'info',
        component: pageInfo,
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: pageNotifications,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js